<template>
  <tr class="order-notes" :class="{ collapsed: !active }">
    <td colspan="11">
      <div class="notes-wrapper">
        <div class="notes-inner-wrapper">
          <div class="notes" ref="notesBox">
            <p v-if="!!deprNotes" v-html="nl2br(deprNotes)" />
            <p v-for="item in notes" :key="item.id">
              <span>{{ moment(item.createdAt).format('DD-MM-YYYY | HH:mm') }}</span>
              <span> - </span>
              <span>{{ `${item.createdBy.firstName} ${item.createdBy.lastName}` }}</span>
              <span>: </span>
              <span>{{ item.content }}</span>
            </p>
          </div>
          <div class="notes-input">
            <form @submit="addNotes">
              <text-input
                :placeholder="$t('ENTER_NOTES')"
                icon-position="right"
                v-model="notesInputVal"
                ref="notesInput"
              >
                <template v-slot:icon>
                  <font-awesome-icon class="icon right" :icon="faPaperPlane" @click="addNotes" />
                </template>
              </text-input>
              <button type="submit" cloak />
            </form>
          </div>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import { watch, ref } from '@vue/composition-api';
import moment from 'moment';
import nl2br from 'nl2br';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';

import TextInput from '@/components/TextInput';

import OrderManagementService from '@/views/Order/OrderManagementService';

export default {
  name: 'OrderNotes',
  components: {
    TextInput,
    FontAwesomeIcon
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    active: Boolean,
    deprNotes: String
  },
  setup(props) {
    const notes = ref([]);
    const notesInputVal = ref('');
    const notesInput = ref(null);
    const notesBox = ref(null);

    const fetchNotes = async () => {
      const { id } = props;
      if (!id) return;

      notes.value = await OrderManagementService.getOrderNotes(id);
    };

    const addNotes = async (e) => {
      e.preventDefault();

      const { id } = props;
      if(!id) return;

      if(!notesInputVal.value) return;

      await OrderManagementService.addOrderNotes(id, notesInputVal.value);
      await fetchNotes();
      notesInputVal.value = '';
    };

    watch(props, ({ active }) => {
      if (active) {
        fetchNotes();
      }
    });

    watch(notes, () => {
      if (!notesBox.value) return;

      notesBox.value.scrollTop = notesBox.value.scrollHeight;
    });

    return {
      notes,
      moment,
      faPaperPlane,
      notesInputVal,
      notesInput,
      notesBox,
      addNotes,
      nl2br
    };
  },
};

</script>

<style lang="scss">
@import "~@/assets/scss/colors";

.order-notes {
  td {
    transition: all .2s ease-in-out;
    border: 1px solid $alto;

    .notes-wrapper {
      height: 244px;
      transition: all .2s ease-in-out;
      text-align: left;

      .notes-inner-wrapper {
        position: relative;
        padding-bottom: 40px;
        height: 100%;
        width: 100%;

        .notes {
          font-size: 14px;
          height: 100%;
          overflow-y: scroll;
          margin-left: 10px;
          margin-top: 10px;

          p {
            margin: 0;

            span {
              color: $lavenderGrey;

              &:last-child {
                color: $independence;
              }
            }
          }
        }

        .notes-input {
          position: absolute;
          width: calc(100%);
          height: 40px;
          bottom: -10px;

          .text-input {
            width: 100%;

            input {
              border: 0;
              border-top: 1px solid $alto;
              height: 31px;
            }

            .icon {
              transition: all .2s ease-in-out;
              cursor: pointer;

              &:hover {
                color: $paradisePink;
              }
            }
          }
        }
      }
    }
  }

  &.collapsed {
    td {
      padding: 0 !important;
      border: 0 !important;

      .notes-wrapper {
        height: 0;
        overflow: hidden;
      }
    }
  }
}
</style>
